<div class="container">
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex header-top__info-links flex-grow-1">
      <a appRouterContext="header-top" i18n-routerLink routerLink="/info/betingelser">
        @if (showOnDk) {
          <i class="supervin-icon-bottle-check"></i> <span i18n>Supervins unikke <strong>vingaranti</strong></span>
        } @else {
          <i class="supervin-icon-bottle-check"></i> <span i18n>Supervin afregner moms og afgifter direkte med svenske Skatteverket</span>
        }
      </a>
      <a appRouterContext="header-top" i18n-routerLink routerLink="/info/kontakt-os">
        <app-comments-icon/>
        <span i18n>Kundeservice: <strong>+45 98 92 18 53</strong></span>
        @if (showB2B) {
          |
          <span i18n>Erhverv: <strong>+45 81 61 16 38</strong></span>
        }
      </a>
      @if (minimumFreightPrice() && freeDeliveryStartsFrom()) {
        <a appRouterContext="header-top" routerLink="/info/leveringsinformation" i18n-routerLink>
          <i class="supervin-icon-truck"></i>
          <span i18n>
            Fragt fra {{ minimumFreightPrice() | number }},- |
            Fri fragt {{ freeDeliveryStartsFrom() | number }},-
          </span>
        </a>
      }
    </div>
    <app-country-selector></app-country-selector>
  </div>
</div>
